import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';
import {
  iniciarNotificacionesNativas,
  detenerNotificacionesNativas,
  registrarPush,
} from '../services/notificacionesNativas';

export default function NotificacionesNativasInit() {
  const navigate = useNavigate();

  useEffect(() => {
    const { data } = supabase.auth.onAuthStateChange((evento, session) => {
      if (evento === 'INITIAL_SESSION' || evento === 'SIGNED_IN') {
        const id = session?.user?.id;
        if (id) {
          iniciarNotificacionesNativas(id, navigate);
          registrarPush(id, navigate);
        }
      } else if (evento === 'SIGNED_OUT') {
        detenerNotificacionesNativas();
      }
    });

    return () => {
      data.subscription.unsubscribe();
      detenerNotificacionesNativas();
    };
  }, [navigate]);

  return null;
}